module.exports = __webpack_public_path__ + "static/media/nexo-borrow.2.5675201a.png";